var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.818.682v1.023H4.091V.682a.682.682 0 0 0-1.364 0v1.023h-.682A2.043 2.043 0 0 0 0 3.75v13.295a2.043 2.043 0 0 0 2.045 2.046h10.91A2.043 2.043 0 0 0 15 17.045V3.75a2.043 2.043 0 0 0-2.045-2.045h-.682V4.09c.003.925-1.365.892-1.364 0V1.705H8.182V.682a.682.682 0 0 0-1.364 0zm-4.09 1.023V4.09c-.005.916 1.358.9 1.363 0V1.705H2.727zm8.181 0h1.364V.682a.682.682 0 0 0-1.364 0v1.023zm.682 5.113H3.409a.682.682 0 0 0 0 1.364h8.182a.682.682 0 0 0 0-1.364zm0 3.41H3.409a.682.682 0 0 0 0 1.363h8.182a.682.682 0 0 0 0-1.364zm0 3.408H3.409a.682.682 0 0 0 0 1.364h8.182a.682.682 0 0 0 0-1.364zM6.818 1.705V4.09c-.003.882 1.365.933 1.364 0V1.705H6.818z",
    fill: "#0b1319",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.97e62b864fd4541185c38256a6640be0.svg";
export { ForwardRef as ReactComponent };